import { openPopup } from './popups'; 
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";


export const urlParams = () => {

	// Check to see if we're using any custom URL params on load (after a timeout so allow 3rd parties to load)
	setTimeout(() => {
		handleURLParamsFunctionality(window.location.href);
	},750);
	

	let allATags = document.querySelectorAll('a');
	allATags.forEach((aTag) => { //Loop through each and give it a onclick event listener

		let linkHref = aTag.getAttribute('href');
		if(linkHref){
			if (linkHref.indexOf("#") != -1) {
				aTag.addEventListener('click', (event) => {
					event.preventDefault();
					let targetEl = event.target.getAttribute('href');
					if(targetEl == null){
						targetEl = event.target.parentElement.getAttribute('href');
					}

					handleURLParamsFunctionality(targetEl);
					return false;
				});
			}
		}		
	});


}




function handleURLParamsFunctionality(href){
	
	//#scrollTo:ElementIDToScrollTo  |   Will either load the page and scroll to that element ID, or scroll on click
	//#book:LocationName     		 |   Will trigger the resevations popup. Add a location name to preselect that location
	//#popup:PopupID				 |   Will open a specific popup.
	

	if (href.indexOf("#") != -1) { //Check if the link has a #
		let hashRaw = href.split('#')[1],
			hashValue = hashRaw.split(':');

		if(hashValue[0] == 'book'){	

			document.querySelector('#reservations').classList.remove('private-dining'); //Remove class hiding the OT widget

			//Preselect the venue if passed through as the 2nd value
			let dmnVenueContainer 	= document.querySelector('.dmn-form .dmn-venue-container')
				dmnVenueSelect 		= document.querySelector('#dmn-venue'),
				dmnExtraFields 		= document.querySelector('.dmn-form .main-inputs'),
				otSelect 			= document.querySelector('#restaurant_rid');

			if(dmnVenueContainer && dmnVenueSelect && dmnExtraFields && otSelect){

				if(hashValue[1]){ //Location has been passed through

					//Check to see if we have the OT & DMN keys matching this location
					let preselectLocation;
					if(locationsBookingData.hasOwnProperty(hashValue[1])){
						preselectLocation = locationsBookingData[hashValue[1]];
					}else{
						preselectLocation = false;
					}

					if(preselectLocation){
						console.log(preselectLocation);

						if(preselectLocation.ot){
							otSelect.value = preselectLocation.ot;
							otSelect.dispatchEvent(new Event('change')); //Manually fire a change event so corrosponding logic updates
							//window.otSelectChoices.setChoiceByValue(preselectLocation.ot);
					
						}

					
						dmnVenueSelect.value = preselectLocation.dmn;
						dmnVenueSelect.dispatchEvent(new Event('change'));
						//window.dmnSelectChoices.setChoiceByValue(hashValue[1]);
						dmnVenueContainer.classList.add('venue-selected');
						dmnExtraFields.classList.remove('invisible');

						
					}
				}else{
					//Add additional styles to the default DMN widget
					dmnVenueSelect.value = null;
					dmnVenueContainer.classList.remove('venue-selected');
					dmnExtraFields.classList.add('invisible');

					otSelect.value = null;
					//window.otSelectChoices.setChoiceByValue("0");
				}


			}
			

			openPopup('#reservations');

		}else if(hashValue[0] == 'enquire'){	

			document.querySelector('#reservations').classList.add('private-dining'); //Add class so we can hide the OT widget

			//Preselect the venue if passed through as the 2nd value
			let dmnVenueContainer 	= document.querySelector('.dmn-form .dmn-venue-container')
				dmnVenueSelect 		= document.querySelector('#dmn-venue'),
				dmnExtraFields 		= document.querySelector('.dmn-form .main-inputs'),
				otSelect 			= document.querySelector('.ot-select');

			if(dmnVenueContainer && dmnVenueSelect && dmnExtraFields && otSelect){

				if(hashValue[1]){ //Location has been passed through

					//Check to see if we have the OT & DMN keys matching this location
					let preselectLocation;
					if(locationsBookingData.hasOwnProperty(hashValue[1])){
						preselectLocation = locationsBookingData[hashValue[1]];
					}else{
						preselectLocation = false;
					}

					if(preselectLocation){
						console.log(preselectLocation);

						if(preselectLocation.ot){
							otSelect.value = preselectLocation.ot;
							window.otSelectChoices.setChoiceByValue(preselectLocation.ot);
					
						}

					
						dmnVenueSelect.value = preselectLocation.dmn;
						dmnVenueSelect.dispatchEvent(new Event('change'));
						//window.dmnSelectChoices.setChoiceByValue(hashValue[1]);
						dmnVenueContainer.classList.add('venue-selected');
						dmnExtraFields.classList.remove('invisible');

						
					}
				}else{
					//Add additional styles to the default DMN widget
					dmnVenueSelect.value = null;
					dmnVenueContainer.classList.remove('venue-selected');
					dmnExtraFields.classList.add('invisible');

					otSelect.value = null;
					window.otSelectChoices.setChoiceByValue("0");
				}


			}

			openPopup('#reservations');

		}else if(hashValue[0] == 'scrollTo'){	
			//Scroll to the element!
			let elementToScrollTo = document.querySelector('#' + hashValue[1]);
			if(elementToScrollTo){
				
				locationPageSubnavs = document.querySelectorAll(".m__lsubnav");
				if(locationPageSubnavs){
					document.querySelector("#js__body").classList.remove('js__popup-active');
					locationPageSubnavs.forEach((subnav) => {
						subnav.classList.remove('open');
					});
				}
				gsap.registerPlugin(ScrollToPlugin);
				gsap.to(window, {duration: 1, scrollTo: elementToScrollTo});
			}
		}else if(hashValue[0] == 'popup'){

			if(hashValue[1] == 'newsletter') {
				const newsletterEmail = document.getElementById('newsletter-email').value;
		        const form = document.getElementById('newsletter-signup-form');
 				const emailAddressInput = form.querySelector('input[name="email_address"]');
        		emailAddressInput.value = newsletterEmail;
			}

			if(hashValue[1] != null && hashValue[1] > ''){
				openPopup('#'+hashValue[1]);
			}
		}else{
			return false;
		}

	}
}
